import { createAction } from '@reduxjs/toolkit';

const ACTIVATE_SUB_NAV = 'zola/vendors/menu/ACTIVATE_SUB_NAV';
const HIDE_SUB_NAV = 'zola/vendors/menu/HIDE_SUB_NAV';

export const activatingSubNav = createAction(ACTIVATE_SUB_NAV);
export const hidingSubNav = createAction(HIDE_SUB_NAV);
